
var swiperSocial = new Swiper(".socialmedia__post", {
  slidesPerView: 1.3,
  spaceBetween: 0,
  loop: true,
  centeredSlides: true,
  navigation: {
    nextEl: ".swiper-button-next.s.pdp",
    prevEl: ".swiper-button-prev.s.pdp",
  },
  breakpoints: {
    550: {
      slidesPerView: 2,
      spaceBetween: 16,
      centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next.s.pdp",
        prevEl: ".swiper-button-prev.s.pdp",
      },
    },
    768: {
      slidesPerView: 3.3,
      spaceBetween: 16,
      centeredSlides: true,
    },
    972: {
      slidesPerView: 4.5,
      spaceBetween: 16,
      centeredSlides: false,
    },
  },
 

});

